// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__qvr_B","alertIcon":"ConfirmModal_alertIcon__Ub_Rj"};